// Configuración del entorno
const config = {
  // URL de la API
  apiUrl: process.env.REACT_APP_API_URL || '/api',
  
  // Entorno
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  
  // Configuración de la aplicación
  appName: 'Portal Académico',
  appVersion: '1.0.0',
  
  // Configuración de timeout
  requestTimeout: 10000, // 10 segundos
  
  // Configuración de reintentos
  maxRetries: 3,
  retryDelay: 1000, // 1 segundo
};

export default config;
